import {
  Box as MuiBox,
  CircularProgress as MuiCircularProgress,
  useTheme,
} from '@mui/material';
import { Button, DeleteButton, Dialog } from 'components';
import { Typography } from 'components/ui';
import { useTranslation } from 'react-i18next';
import CancelButton from 'components/Buttons/CancelButton';
import TableUserInfo from 'components/TableUserInfo';
import useCheckBlockingOptions from 'lib/hooks/useCheckBlockingOptions';

const ReinviteDialog = (props) => {
  const { close, initialData } = props;
  const { t } = useTranslation();
  const { user } = initialData;

  const theme = useTheme()
  
  return (
    <Dialog
      {...props}
      maxWidth="xs"
      title={initialData?.dialogTitle}
      onClose={close}
    >
      <Typography style={{ color: theme.palette.colors.gray400, width: '520px' }} mb={5}>
        {initialData?.dialogWarningMessage}
      </Typography>
      <MuiBox style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
        <TableUserInfo isPatient={true} isActive user={user} isDialog />
      </MuiBox>
      <MuiBox
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: '20px',
          gap: 1,
        }}
      >
        <MuiBox style={{ display: 'flex', gap: 10, marginLeft: 'auto' }}>
          <CancelButton
            variant="outlined"
            onClick={() => close({ isReinvited: false })}
          />
          <Button
            style={{ height: 40 }}
            icon={false}
            onClick={() => close({ isReinvited: true })}
            title={
              initialData?.loading ? (
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <MuiCircularProgress
                    style={{ width: '20px', height: '20px' }}
                  />
                </div>
              ) : (
                t('Reinvite')
              )
            }
          />
        </MuiBox>
      </MuiBox>
    </Dialog>
  );
};

export default ReinviteDialog;
